import classnames from 'classnames';
import * as React from 'react';
import eurasiaLogo from '../../assets/img/eurasia-logo.png';
import eurasiaSingleLogo from '../../assets/img/eurasia-single-logo.png';
import './eurasia-logo.less';


interface IEurasiaLogoProps {
    width?: number
    single?: boolean
    className?: any
}

const EurasiaLogo = ({ width, single, className }: IEurasiaLogoProps) => {
    return (
        <div className={classnames('eurasia-logo', className)}>
            <img alt="Eurasia Logo" src={single ? eurasiaSingleLogo : eurasiaLogo} width={width}/>
        </div>
    );
};

export default EurasiaLogo;
